import UpgradeDisclaimer from './UpgradeDisclaimer';

export default UpgradeDisclaimer;
